import { useState } from 'react';
import { PlusIcon } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { ActionBar } from '@/components';
import { ActionType, DividerOrientation } from '@/components/ActionBar';
import type { ActionConfig } from '@/components/ActionBar';
import { OverlayNames, useOverlayManager } from '@/hooks';
import { Permission } from '@/types/permissions';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import { useCameraLimitReached } from '@/features/SettingsView/hooks/useCameraLimitReached';
import { LimitBadge, LimitPopoverContent } from '@/components/LimitBadge';

interface CamerasActionBarProps {
    onSearchSubmit: (value: string) => void;
}

export function CamerasActionBar({ onSearchSubmit }: CamerasActionBarProps) {
    const { t } = useTranslation(I18nNamespace.CAMERAS);
    const { open } = useOverlayManager();
    const [searchDraft, setSearchDraft] = useState('');
    const isAtLimit = useCameraLimitReached();

    const actions: ActionConfig[] = [
        {
            type: ActionType.SEARCH,
            value: searchDraft,
            onChange: setSearchDraft,
            onSubmit: onSearchSubmit,
        },
        { type: ActionType.DIVIDER, orientation: DividerOrientation.VERTICAL },
        {
            type: ActionType.ITEM,
            icon: PlusIcon,
            label: t('actions.addCamera'),
            onClick: isAtLimit
                ? undefined
                : () => open(OverlayNames.ADD_CAMERA, {}),
            permission: Permission.CREATE,
            disabled: isAtLimit,
            trailingBadge: isAtLimit ? (
                <LimitBadge showLabel={true} />
            ) : undefined,
            content: isAtLimit ? (
                <LimitPopoverContent
                    title={t('atCapTitle')}
                    hint={t('atCapHint')}
                />
            ) : undefined,
        },
    ];

    return <ActionBar actions={actions} />;
}
